import React from 'react'
import { useTranslation } from 'react-i18next'
import { TextAction } from '@node-space/storybook-components/dist/TextAction'
import { Description } from 'components/Text'
import { ExternalLinks } from 'constants/ExternalLinks'

export interface SignUpAgreementProps {
  isDevXSignup?: boolean
}

export const SignUpAgreement = ({ isDevXSignup }: SignUpAgreementProps) => {
  const { t } = useTranslation()

  if (!isDevXSignup) return

  return (
    <Description>
      {t('signUpAgreementIntro')}{' '}
      <TextAction
        text={t('termsConditionsDevX')}
        className="text-secondary-500"
        linkTo={ExternalLinks.termsAndConditionsDevX}
      />
    </Description>
  )
}
